import React from 'react';
import * as S from './OfferSlider.styles';
import newTag from '../../assets/new-tag.png';

const OfferSlider = ({ data }) => {
  return (
    <S.OfferSlider >
      <div>
        {
          data.map(({ id, theme, icon, offferText, showNew }) => (
            <div key={id} className="offrSlider__item">
              <S.NewTag>New</S.NewTag>
              <div className={`offrSlider__itemIcon ${theme ? theme : ''}`}>
                {!showNew && <span className={icon}></span>}
                {showNew && <img src={icon} width={24} />}
              </div>
              <div className='offrSlider__itemDesc'>
                <p className='offrSlider__item--text' dangerouslySetInnerHTML={{ __html: offferText }} />
              </div>
            </div>
          ))
        }
      </div>
      <div>
        {
          data.map(({ id, theme, icon, offferText, showNew }) => (
            <div key={id} className="offrSlider__item">
              <S.NewTag>New</S.NewTag>
              <div className={`offrSlider__itemIcon ${theme ? theme : ''}`}>
                {!showNew && <span className={icon}></span>}
                {showNew && <img src={icon} width={24} />}
              </div>
              <div className='offrSlider__itemDesc'>
                <p className='offrSlider__item--text' dangerouslySetInnerHTML={{ __html: offferText }} />
              </div>
            </div>
          ))
        }
      </div>
    </S.OfferSlider >
  )
}

export default OfferSlider;